export default __webpack_public_path__ + "static/media/metalfloor2.b808646a.png";